import type { CheckoutReady } from '../../bot-core/types/chat.types';

const CART_MUTATING_TOOLS = new Set(['add_to_cart', 'remove_from_cart']);
const CHECKOUT_TOOLS = new Set(['initiate_checkout', 'generate_checkout_url']);

export interface BotTurnCompleteMeta {
  lastTool?: string | null;
  checkoutReady?: CheckoutReady;
}

/** Shared post-turn hook: refresh itinerary + checkout payload when the cart changes. */
export async function handleBotTurnComplete(
  sessionId: string,
  meta: BotTurnCompleteMeta,
  refreshSelections: (id: string) => Promise<void>,
  fetchCheckout: (id: string, expiresAt?: string | null) => Promise<void>,
  hasActiveCheckout?: () => boolean,
): Promise<void> {
  await refreshSelections(sessionId);

  const tool = meta.lastTool ?? null;
  if (tool && CHECKOUT_TOOLS.has(tool)) {
    const expiresAt =
      tool === 'generate_checkout_url' ? meta.checkoutReady?.expires_at : undefined;
    await fetchCheckout(sessionId, expiresAt);
    return;
  }

  if (tool && CART_MUTATING_TOOLS.has(tool) && hasActiveCheckout?.()) {
    await fetchCheckout(sessionId);
  }
}
